<template>
  <v-layout row wrap>
    <v-flex>
      <iframe src="https://calendar.google.com/calendar/embed?height=600&amp;wkst=1&amp;bgcolor=%23ffffff&amp;ctz=Asia%2FKuala_Lumpur&amp;src=M3JkbmY5NHFzMWNoNWkwMjRvNDUxczRwY29AZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=cHM4N2w0bnRpOTZ1dmlvYzM0Nm83YWtlcHNAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=ZW4ubWFsYXlzaWEjaG9saWRheUBncm91cC52LmNhbGVuZGFyLmdvb2dsZS5jb20&amp;color=%234285F4&amp;color=%237CB342&amp;color=%233F51B5&amp;title=MYCO2%20Calendar" style="border-width:0" width="100%" height="550px" frameborder="0" scrolling="no"></iframe>
    </v-flex>
  </v-layout>
</template>


<script>
import auth from "../../functions/auth";

export default {
  name: "Calendar_google",
  // components: {
  //   PageLayout: PageLayout
  // },
  data: () => ({
  }),
  async mounted() {
    this.username = auth.getUsername();
    auth.hideHeader(true);
    auth.hideFooter(true);
  },
  methods: {
  }
};
</script>


<style>
</style>